import { render, staticRenderFns } from "./RelativeRelationEdit.vue?vue&type=template&id=44f89c81&scoped=true&"
import script from "./RelativeRelationEdit.vue?vue&type=script&lang=js&"
export * from "./RelativeRelationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f89c81",
  null
  
)

export default component.exports